export const css = {
    root: '_2P1-uTkI',
    loading: 'RxKrerFa',
    instructions: '_3nTGgrV1',
    score: '_3hLcn-o8',
    scoreTitle: '_10yAqPCl',
    scorePercent: '_1rjT6yKD',
    actions: '_1QeENSS4',
    oneaction: '_2urRd6pm',
    nextprev: 'eAnUXe4F',
    previous: 'TaTEDEMc',
    next: 'Oe7xzH1Q',
    recommendedReading: '_1lKNl2ZM',
    timerblock: 'ljkJxhSg',
    timer: '_3ob8zHTW',
    ' _key': 'quiz-widgets/questionfeedback'
};
export default css;
